import type { Resource } from '~/types/graphql';

import { useSyncResourceTriggerMutation } from '~/api/graphql/queries/syncResourceTrigger.generated';
import { useMakeWinnerStore } from '../../stores';
import { TemplateType } from '~/types/template';
import { useCallback } from 'react';

const TEMPLATE_TYPE_TO_RESOURCE: Partial<Record<TemplateType, Resource>> = {
  [TemplateType.COLLECTION]: 'COLLECTION',
  [TemplateType.PRODUCT]: 'PRODUCT',
  [TemplateType.ARTICLE]: 'ARTICLE',
  [TemplateType.PAGE]: 'PAGE',
  [TemplateType.BLOG]: 'BLOG',
};

export const useFetchSyncResource = () => {
  const makeWinnerMetadata = useMakeWinnerStore((state) => state.makeWinnerMetadata);
  const controlTemplateType = makeWinnerMetadata?.control.templateType as TemplateType | undefined;

  const { mutateAsync, isLoading } = useSyncResourceTriggerMutation();
  const { mutateAsync: mutateAsyncBlog, isLoading: isLoadingBlog } =
    useSyncResourceTriggerMutation();

  const syncResource = useCallback(async () => {
    if (!controlTemplateType) return;

    const resource = TEMPLATE_TYPE_TO_RESOURCE[controlTemplateType];
    if (!resource) return;

    if (controlTemplateType === TemplateType.ARTICLE) {
      await mutateAsyncBlog({ input: { platform: 'SHOPIFY', resource: 'BLOG' } });
    }

    await mutateAsync({ input: { platform: 'SHOPIFY', resource } });
  }, [controlTemplateType, mutateAsync, mutateAsyncBlog]);

  return { syncResource, isSyncing: isLoading || isLoadingBlog };
};
